'use client'

import dynamic from 'next/dynamic'
import { Suspense } from 'react'

// Cargar 404Experience dinámicamente
const Experience404 = dynamic(
  () => import('@/client/components/canvas/context/Error404Experience').then(mod => mod.default),
  { ssr: false }
)

export const runtime = 'edge'

/**
 * @fileoverview Custom 404 Not Found page component with dynamic 3D experience
 * @module not-found
 *
 * @requires next/dynamic
 * @requires react
 * @requires @/client/components/canvas/context/404Experience
 *
 * @exports {string} runtime - Edge runtime configuration
 * @exports {Function} NotFound - Default 404 page component
 *
 * @description
 * This module provides a custom 404 page with a dynamically loaded 3D experience.
 * The 3D experience component is loaded client-side only (SSR disabled) to prevent
 * hydration errors. While loading, it displays fallback content.
 *
 * The page uses Next.js Edge runtime for optimal performance.
 */
export default function NotFound() {
  return (
    <>
      <Suspense fallback={<div className='text-center'>No se encontró el contenido...</div>}>
        <Experience404 id='not-found-3d' />
      </Suspense>
    </>
  )
}
